import { APP_CONTEXT } from '../pixeltrade/app.action';
import { DateHelper } from '../pixeltrade/date.helper';
import { ORDER_CONTEXT } from '../pixeltrade/strategies/trend-stocks/order-context.action';
import { TREND_STOCK_CONTEXT } from '../pixeltrade/strategies/trend-stocks/trendstock.action';
import { IAppState } from './appstate';

export const INITIAL_STATE: IAppState = {
    trendstockState: {
        refresh: false,
        breakoutDays: 3,
        changePercentage: 1,
        positionSize: 25000,
        stoploss: 1,
        apiKey: 'XXXXXXXXXXXX',
        isCurrentTrend: false
    },
    appContext: {
        today: DateHelper.getWorkingDay()
    },
    orderState: {
        refresh: false,
        isOffsetEnabled: true,
        isStrikeEnabled: false,
        stopLossOffset: 3000,
        targetOffset: 3000,
        lotSize: 1,
        product: 'NRML',
        isSpotPriceEntry: false,
        tag: 'hb',
        tags: '',
        comment: '',
        isNextExpiry: false,
        isPriceEntry: false,
        isLimit: false,
        open: true,
        closed: false,
        pending: false,
        ceBuyPremium: 0,
        ceSellPremium: 0,
        peBuyPremium: 0,
        peSellPremium: 0,
        isOptionPriceExit: true,
        isOptionLimit: false,
        simpleView: false,
        isTrail: true
    }
}



function trendstockContext(state, action): IAppState {

    return Object.assign({}, state, {
        trendstockState: action.trendstockState
    });
}

function orderContext(state, action): IAppState {

    return Object.assign({}, state, {
        orderState: action.orderContext
    });
}

function appContext(state, action): IAppState {

    return Object.assign({}, state, {
        trendstockState: action.appContext
    });
}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case TREND_STOCK_CONTEXT:
            return trendstockContext(state, action);
        case APP_CONTEXT:
            return appContext(state, action);
        case ORDER_CONTEXT:
            return appContext(state, action);
        default:
    }
    return state;
}